import learningportalSvg from "../assets/image/learningportal.svg";

export default function AuthLayout({
  isForLogin,
  children,
  title = "",
  onSubmit,
}) {
  return (
    <section className="py-6 bg-primary h-screen grid place-items-center">
      <div className="mx-auto max-w-md px-5 lg:px-0">
        <div>
          <img
            className="h-12 mx-auto"
            src={learningportalSvg}
            alt="learningportalSvg logo"
          />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
            {!title
              ? isForLogin
                ? "Sign in to Student Account"
                : "Create Your New Account"
              : title}
          </h2>
        </div>
        <form
          className="mt-8 space-y-6"
          action="#"
          method="POST"
          onSubmit={onSubmit}
        >
          <input type="hidden" name="remember" defaultValue="true" />
          {children}
          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
            >
              {isForLogin ? "Sign in" : "Create Account"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
